import { render } from "./Maininput.vue?vue&type=template&id=2dc1d9f8&scoped=true"
import script from "./Maininput.vue?vue&type=script&lang=js"
export * from "./Maininput.vue?vue&type=script&lang=js"

import "./Maininput.vue?vue&type=style&index=0&id=2dc1d9f8&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dc1d9f8"]])

export default __exports__